const connector = ['Flowchart', { stub: [20, 30], gap: 10, cornerRadius: 5 }];
const startEnpointOptions = {
  connector,
  endpoint: ['Rectangle', { cssClass: 'source-start el-icon-icon-play4' }],
  isSource: true,
  anchor: [0, 0, 1, 0, 30, 30],
};
const targetEndpointOptions = {
  endpoint: ['Dot', { radius: 6, cssClass: 'target' }],
  maxConnections: -1,
  isTarget: true,
  anchor: ['Top'],
};

const sourceTrueOptions = {
  connector,
  endpoint: ['Rectangle', { cssClass: 'source-success el-icon-icon-checkmark3' }],
  isSource: true,
  // connectorOverlays: [['Diamond', { location: 0 }]],
};

const sourceFalseOptions = {
  connector,
  endpoint: ['Rectangle', { cssClass: 'source-fail el-icon-icon-cross2' }],
  isSource: true,
};

const sourceTimeoutOptions = {
  connector,
  endpoint: ['Rectangle', { cssClass: 'source-timeout el-icon-icon-bell2' }],
  isSource: true,
};

const sourceAbortOptions = {
  connector,
  endpoint: ['Rectangle', { cssClass: 'source-abort el-icon-icon-stop2' }],
  isSource: true,
};

const trueConnector = {
  paintStyle: {
    stroke: '#67c23a',
  },
};

const falseConnector = {
  paintStyle: {
    stroke: '#f56c6c',
  },
};

const timeoutConnector = {
  paintStyle: {
    stroke: '#E6A23C',
  },
};

const abortConnector = {
  paintStyle: {
    stroke: '#909399',
  },
};

export default class Flow {
  $: JQueryStatic;

  endpoints: any;

  jsPlumb: any;

  $dragEnd: any;

  $connectionDetached: any;

  $connectionAttached: any;

  $nodeClick: any;

  $nodeDoubleClick: any = null;

  $nodeTriggerClick: any;

  $nodeTriggerStartStepChanged: (node: string, triggerId: number, connected: boolean) => void;

  $nodeValidationErrorCallback: any;

  nodeTypes: any[];

  constructor($, jsPlumb, nodeTypes) {
    this.$ = $;
    this.jsPlumb = jsPlumb;
    this.nodeTypes = nodeTypes;
    this.endpoints = {};
  }

  init(dragEndCallback, connectionAttachedCallback, connectionDetachedCallback, nodeClickCallback, nodeTriggerStartStepChanged, nodeTriggerClick, nodeValidationErrorCallback?, nodeDoubleClickCallback?) {
    return new Promise<void>((fullfill) => {
      this.jsPlumb.ready(() => {
        this.$dragEnd = dragEndCallback;
        this.$connectionDetached = connectionDetachedCallback;
        this.$connectionAttached = connectionAttachedCallback;
        this.$nodeClick = nodeClickCallback;
        this.$nodeTriggerStartStepChanged = nodeTriggerStartStepChanged;
        this.$nodeValidationErrorCallback = nodeValidationErrorCallback;
        this.$nodeTriggerClick = nodeTriggerClick;
        this.$nodeDoubleClick = nodeDoubleClickCallback;
        fullfill();
      });
    });
  }

  createFlow(flowData, triggers, container) {
    $(container).html('');
    this.endpoints = {};
    const instance = this.jsPlumb.getInstance({
      DragOptions: {
        cursor: 'pointer',
        zIndex: 5000,
      },
      ConnectionOverlays: [
        [
          'Arrow',
          {
            location: 1,
            width: 11,
            length: 11,
            id: 'arrow',
            foldback: 0.8,
            paintStyle: {
              lineWidth: 3,
            },
          },
        ],
        [
          'Label',
          {
            id: 'label',
            cssClass: 'connection-label',
            location: 0.8,
          },
        ],
      ],
      Container: $(container),
    });

    instance.registerConnectionTypes({
      true: {
        ...trueConnector,
      },
      false: {
        ...falseConnector,
      },
      timeout: {
        ...timeoutConnector,
      },
      abort: {
        ...abortConnector,
      },
    });

    instance.bind('connection', (info) => {
      if (info.sourceId === 'flowStart') {
        info.connection.getOverlay('label').setLabel('Start');
        return;
      }
      if (info.sourceEndpoint.connectionLabel) {
        info.connection.getOverlay('label').setLabel(info.sourceEndpoint.connectionLabel);
      }
    });

    instance.batch(() => {
      for (const node of flowData) {
        const nodeType = this.getNodeType(node);
        if (!nodeType) {
          continue;
        }
        let successAnchor = [1, nodeType.endpoints[2] ? 0.7 : 0.5, 1, 0];
        let failAnchor = [0, nodeType.endpoints[3] ? 0.7 : 0.5, -1, 0];
        let timeoutAnchor = [1, nodeType.endpoints[0] ? 0.3 : 0.5, 1, 0];
        let abortAnchor = [0, nodeType.endpoints[1] ? 0.3 : 0.5, -1, 0];

        const jQueryNode = $(`<div class="node" id="id_${node.guid}"></div>`);
        if (node.position && node.position.length === 2) {
          jQueryNode.css({
            top: node.position[0],
            left: node.position[1],
          });
        }
        if (nodeType.name.indexOf('.') > -1) {
          const typeDefinition = nodeType.name.substring(0, nodeType.name.indexOf('.')).toLowerCase();
          jQueryNode.addClass(typeDefinition);
          if (typeDefinition === 'conditions') {
            successAnchor = [1, 0.5, 1, 0, 5, 0];
            abortAnchor = timeoutAnchor = failAnchor = [0, 0.5, -1, 0, -5, 0];
          }
        }
        this.$(container).append(jQueryNode);
        const targetEndpoint = instance.addEndpoint($(`#id_${node.guid}`), { uuid: `target_${node.guid}` }, { ...targetEndpointOptions });

        const sourceEndpoints = new Array(4);
        if (nodeType.endpoints[0]) {
          const ep = instance.addEndpoint(
            $(`#id_${node.guid}`),
            { uuid: `true_${node.guid}` },
            {
              ...sourceTrueOptions,
              connectionType: 'true',
              connectorPaintStyle: { stroke: 'red', strokeWidth: 10 },
              anchor: successAnchor,
            },
          );
          ep.connectionLabel = nodeType.endpointLabels[0];
          sourceEndpoints[0] = ep;
        }
        if (nodeType.endpoints[1]) {
          const ep = instance.addEndpoint(
            $(`#id_${node.guid}`),
            { uuid: `false_${node.guid}` },
            {
              ...sourceFalseOptions,
              connectionType: 'false',
              anchor: failAnchor,
            },
          );
          ep.connectionLabel = nodeType.endpointLabels[1];
          sourceEndpoints[1] = ep;
        }
        if (nodeType.endpoints[2]) {
          const ep = instance.addEndpoint(
            $(`#id_${node.guid}`),
            { uuid: `timeout_${node.guid}` },
            {
              ...sourceTimeoutOptions,
              connectionType: 'timeout',
              anchor: timeoutAnchor,
            },
          );
          ep.connectionLabel = nodeType.endpointLabels[2];
          sourceEndpoints[2] = ep;
        }
        if (nodeType.endpoints[3]) {
          const ep = instance.addEndpoint(
            $(`#id_${node.guid}`),
            { uuid: `abort_${node.guid}` },
            {
              ...sourceAbortOptions,
              connectionType: 'abort',
              anchor: abortAnchor,
            },
          );
          ep.connectionLabel = nodeType.endpointLabels[3];
          sourceEndpoints[3] = ep;
        }

        this.endpoints[node.guid] = {
          sources: sourceEndpoints,
          target: targetEndpoint,
        };

        const hn = this.buildNode(node);
        if (!hn) {
          continue;
        }
        $(jQueryNode).append(hn);

        $(jQueryNode).on('click', () => {
          this.$nodeClick(node.guid);
        });

        if (this.$nodeDoubleClick) {
          $(jQueryNode).on('dblclick', () => {
            this.$nodeDoubleClick(node.guid);
          });
        }

        instance.draggable(jQueryNode, {
          stop: (data) => {
            const elementId = $(data.el).attr('id');
            const nodeId = elementId.split('_')[1];
            const node = flowData.find((n) => n.guid === nodeId);
            this.$dragEnd('node', node, data.pos);
          },
        });
        instance.makeTarget(jQueryNode, {
          endpoint: targetEndpoint,
          dropOptions: {
            hoverClass: 'hover',
            activeClass: 'active',
          },
        });
      }
      for (const node of flowData) {
        const sourceNodeEndpoints = this.endpoints[node.guid];
        for (let i = 0; i < node.connections.length; i += 1) {
          const connection = node.connections[i];
          if (connection) {
            const targetNodeEndpoints = this.endpoints[connection];
            if (targetNodeEndpoints) {
              instance.connect({
                source: sourceNodeEndpoints.sources[i],
                target: targetNodeEndpoints.target,
              });
            }
          }
        }
      }

      for (let j = 0; j < triggers.length; j += 1) {
        const trigger = triggers[j];
        const name = `flowStart_${trigger.id}`;
        const startPoint = (<any>$(`<div class="node start">
        <span class="icon icon-1_5x el-icon-${trigger.icon || 'icon-racing'}"></span>
        <span class="title start-label"><span class="text">${trigger.title}</span></span>
        </div>`).attr({
          id: name,
          triggerId: trigger.id,
          startupStep: trigger.startupStep,
        })).prependTo(container);

        startPoint.css({
          top: trigger.position[0] || 40,
          left: trigger.position[1] || 40 + 80 * j,
        });
        let clickPrevent = false;
        instance.draggable(startPoint, {
          stop: (data) => {
            clickPrevent = true;
            this.$dragEnd('trigger', trigger, data.pos);
          },
        });
        const startEndPoint = instance.addEndpoint($(`#${name}`), { uuid: `target_${name}` }, { ...startEnpointOptions, anchor: ['Left', 'Right'] });

        $(startPoint).on('click', (endpoint, event) => {
          if (!clickPrevent) {
            this.$nodeTriggerClick(trigger, event);
          }
          clickPrevent = false;
        });
        let primaryNode = flowData.filter((f) => f.guid === trigger.startupStep)[0];
        if (!primaryNode) {
          if (flowData.length === 1) {
            primaryNode = flowData[0];
            this.$nodeTriggerStartStepChanged(primaryNode.guid, trigger.id, true);
          }
        }
        if (primaryNode) {
          const primaryEndPoint = this.endpoints[primaryNode.guid];
          if (primaryEndPoint && primaryEndPoint.target) {
            instance.connect({
              source: startEndPoint,
              target: primaryEndPoint.target,
            });
          }
        }
      }
    });

    instance.bind('connectionDetached', (info) => {
      const targetId = info.targetId.split('_')[1];
      if (info.sourceId.indexOf('flowStart_') === 0) {
        this.$nodeTriggerStartStepChanged(targetId, +info.sourceId.substring(10), false);
        return;
      }
      const sourceId = info.sourceId.split('_')[1];
      this.$connectionDetached(sourceId, targetId);
    });

    instance.bind('beforeDrop', (info) => {
      const targetId = info.targetId.split('_')[1];
      if (info.sourceId.indexOf('flowStart_') === 0) {
        return true;
      }
      const sourceId = info.sourceId.split('_')[1];
      const noMultipleTimesNodes = flowData.filter((fdc) => !this.getNodeType(fdc).multipleTimesCapability);
      if (noMultipleTimesNodes.length) {
        for (const noMultipleTimesNode of noMultipleTimesNodes) {
          const res = this.detectLoop(flowData, noMultipleTimesNode, [noMultipleTimesNode.guid], (v) => (v === sourceId ? targetId : null));
          if (res && res.includes(noMultipleTimesNode.guid)) {
            if (this.$nodeValidationErrorCallback) {
              this.$nodeValidationErrorCallback('loop', noMultipleTimesNode);
            }
            return false;
          }
        }
      }
      return true;
    });
    instance.bind('connection', (info) => {
      const targetId = info.targetId.split('_')[1];
      if (info.sourceId.indexOf('flowStart_') === 0) {
        this.$nodeTriggerStartStepChanged(targetId, +info.sourceId.substring(10), true);
        return;
      }
      const sourceId = info.sourceId.split('_')[1];
      let index = 0;
      if (info.connection.hasType('true')) {
        index = 0;
      }
      if (info.connection.hasType('false')) {
        index = 1;
      }
      if (info.connection.hasType('timeout')) {
        index = 2;
      }
      if (info.connection.hasType('abort')) {
        index = 3;
      }
      this.$connectionAttached(sourceId, targetId, index);
    });
  }

  detectLoop(flowData, node, navigatedNodes: string[], injector: (v: string) => string): string[] {
    const nodes = [];
    const connectedNodes = flowData.filter((fdc) => fdc.connections.includes(node.guid) || injector(fdc.guid) === node.guid);
    for (const connectedNode of connectedNodes) {
      if (navigatedNodes.includes(connectedNode.guid)) {
        nodes.push(connectedNode.guid);
      } else {
        for (const nav of this.detectLoop(flowData, connectedNode, [...navigatedNodes, connectedNode.guid], injector)) {
          nodes.push(nav);
        }
      }
    }
    return nodes;
  }

  buildNode(node) {
    const sb = ['<div class="overlay"></div>'];
    const nt = this.getNodeType(node);
    if (nt) {
      sb.push(`<span class="icon-1_5x icon el-icon-${nt.icon}"></span>`);
    }
    sb.push(`<span class="title"><span class="text">${node.title}</span></span>`);
    return sb.join('');
  }

  getNodeType(node) {
    return this.nodeTypes.filter((s) => s.name === node.typeName)[0];
  }

  getNodeTypes() {
    return this.nodeTypes;
  }
}
